import { render, staticRenderFns } from "./BulkFeeding.vue?vue&type=template&id=696ca761&scoped=true&"
import script from "./BulkFeeding.vue?vue&type=script&lang=js&"
export * from "./BulkFeeding.vue?vue&type=script&lang=js&"
import style0 from "./BulkFeeding.vue?vue&type=style&index=0&id=696ca761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ca761",
  null
  
)

export default component.exports